<template>
  <div class="text--primary">
    <v-row dense v-if="itemAprovacao.produto && itemAprovacao.produto.codigo">
      <v-col cols="12" sm="6" class="text-truncate">
        <v-icon small>mdi-pound</v-icon>
        <span class="font-weight-bold">Código interno:</span>
        {{ itemAprovacao.produto.codigo }}
      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <v-btn color="success" small
               class="ml-1 normal-btn-text rounded-tag-small elevation-0">
          <v-icon small>mdi-check</v-icon>Aprovar
        </v-btn>
        <v-btn color="error" small
               class="ml-1 normal-btn-text rounded-tag-small elevation-0">
          <v-icon small>mdi-close</v-icon>Recusar
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="body-1 font-weight-bold">
        {{ descricaoProduto }}
        <px-historico-preco-produto v-if="hasProduto"
                                    small
                                    :produto="itemAprovacao.produto"
                                    :unidade-medida="itemAprovacao.unidadeMedida"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        {{ itemAprovacao.quantidade }}
        {{ itemAprovacao.unidadeMedida.descricao }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="hasProduto">
        <span class="caption font-weight-bold">Especificação</span>
        <div>
          {{ itemAprovacao.especificacaoProduto }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3" v-if="hasProduto && itemAprovacao.produto.precoTarget">
        <span class="caption font-weight-bold">Preço target</span>
        <div>
          {{ itemAprovacao.produto.precoTarget | currency }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Centro de custo</span>
        <div>
          {{ centroCusto | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">Projeto</span>
        <div>
          {{ projeto | naoInformado }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações internas</span>
        <div>
          <px-show-large-text :large-text="itemAprovacao.observacaoInterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações externas</span>
        <div>
          <px-show-large-text :large-text="itemAprovacao.observacaoExterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="itemAprovacao.arquivos && itemAprovacao.arquivos.length">
        <span class="caption font-weight-bold">Anexos</span>
        <px-anexo-chip :files="itemAprovacao.arquivos"
                       download-base-path="files/download-comprador"/>
      </v-col>
    </v-row>
    <px-campos-integracao
      v-if="cadastrosAdicionaisItem && erpCamposIntegracao"
      type="requisicao-produtos-view"
      :form-data="cadastrosAdicionaisItem"/>
  </div>
</template>

<script>
import ObjectUtils from '@/utils/object-utils';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import { mapGetters } from 'vuex';

export default {
  props: {
    itemAprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['erpCamposIntegracao']),
    hasProduto() {
      return !!this.itemAprovacao.produto;
    },
    descricaoProduto() {
      return this.itemAprovacao.produto ? this.itemAprovacao.produto.descricao
        : this.itemAprovacao.especificacaoProduto;
    },
    centroCusto() {
      return this.itemAprovacao.centroCusto
        ? ObjectUtils.descWithCodigoInterno(this.itemAprovacao.centroCusto) : null;
    },
    projeto() {
      return this.itemAprovacao.projeto
        ? ObjectUtils.descWithCodigoInterno(this.itemAprovacao.projeto) : null;
    },
    cadastrosAdicionaisItem() {
      if (!this.itemAprovacao.cadastrosAdicionais
        || !this.itemAprovacao.cadastrosAdicionais.length) {
        return null;
      }
      return cadastrosAdicionaisToMap(this.itemAprovacao.cadastrosAdicionais);
    },
  },
};
</script>
